module.exports = __webpack_public_path__ + "static/media/usb_cellular_step_5@2x.2d944948.png";